



























































































































import { defineComponent } from '@nuxtjs/composition-api'
import accessibility from '~/utils/solepro/accessibility';

export default defineComponent({
    props:{
        closeBackdrop:{
            type: Boolean,
            default: true
        },
        modalClasses:{
            type:String,
            default:''
        }
    },
    data() {
        return {
            sprite: require('~/assets/solepro/spritemap.svg'),
            informativaSinteticaID: 'informativa-sintetica'
        }
    },
    methods: {
        openModal() {
            const modal = document.getElementById(this.informativaSinteticaID)
            const overlay = document.getElementById('modal-backdrop');
            overlay.addEventListener("click", this.closeModalHandler)
            modal.addEventListener("keydown", this.keyDownHandler);

            // Add overlay before modal
            overlay.classList.remove('hidden');
            document.body.classList.add('modal-open');

            // Show modal
            modal.classList.add('show');

            setTimeout(() => {
                accessibility.simpleFocusTrap(modal)
            }, 500);
        },
        closeModal(keepOverlay: Boolean) {
            const modal = document.getElementById(this.informativaSinteticaID);
            const overlay = document.getElementById('modal-backdrop');
            overlay.removeEventListener("click", this.closeModalHandler)
            modal.removeEventListener("keydown", this.keyDownHandler);

            if (!modal) return;
            modal.classList.remove('show');

            if (!keepOverlay) overlay.classList.add('hidden');
            document.body.classList.remove('modal-open');
        },
        closeModalHandler(evt, keepOverlay?: Boolean) {
            this.closeModal(keepOverlay&&!this.closeBackdrop)
        },
        keyDownHandler(evt) {
            if (evt.key === "Escape") {
                this.closeModal(!this.closeBackdrop);
            }
        }

    }
})
